"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CART_CLEANED_BY_CYCLE = void 0;
exports.CART_CLEANED_BY_CYCLE = 'As promoções da loja foram atualizadas. Coloque os produtos no carrinho novamente.';
